import { Link as RouterLink } from "react-router-dom";

import { Icon, SpinnerIcon } from "~/components/icon";
import { pluralize } from "~/utils";

/// Confirmation shown after submitting a fleet operation.
export function FleetCreationResult({
  creating,
  result,
}: {
  creating: boolean;
  result: {
    id: string;
    waveCount: number;
    clusterCount: number;
    description: string;
  } | null;
}) {
  if (creating || result == null) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <SpinnerIcon className="animate-spin" />
        Creating fleet operation…
      </div>
    );
  }
  const { id, waveCount, clusterCount, description } = result;
  return (
    <div className="space-y-3">
      <div className="flex items-baseline gap-2 text-sm">
        <Icon name="Check" size={14} className="shrink-0 text-green-600" />
        <span className="font-medium">Fleet operation created</span>
        <RouterLink
          to={`/fleet-ops#op-${id}`}
          className="ml-auto underline hover:text-slate-700"
        >
          View fleet operation →
        </RouterLink>
      </div>
      {description ? (
        <p className="text-sm text-gray-500">{description}</p>
      ) : null}
      <div className="rounded-md border border-gray-200 bg-gray-50 p-3 text-xs text-gray-600">
        {pluralize(waveCount, "wave")} · {pluralize(clusterCount, "cluster")}
      </div>
      <div className="flex justify-end text-xs text-gray-500">
        Press Esc to close
      </div>
    </div>
  );
}
